<template>
  <div class="user-view-container">
    <h2>用户信息中心</h2>
    <div class="tabs-container">
      <button :class="{ 'active': activeTab === 'basic' }" @click="switchTab('basic')">基本信息</button>
      <button :class="{ 'active': activeTab === 'wenzhen' }" @click="switchTab('wenzhen')">问诊</button>
      <button :class="{ 'active': activeTab === 'voice' }" @click="switchTab('voice')">闻诊</button>
      <button :class="{ 'active': activeTab === 'pulse' }" @click="switchTab('pulse')">脉诊</button>
      <button :class="{ 'active': activeTab === 'face' }" @click="switchTab('face')">面诊</button>
      <button :class="{ 'active': activeTab === 'tongue' }" @click="switchTab('tongue')">舌诊</button>
    </div>

    <div class="content-container">
      <!-- 基本信息 -->
      <div v-if="activeTab === 'basic'" class="tab-content">
        <h3>基本信息</h3>
        <div class="info-item">
          <span class="label">病历号:</span>
          <span class="value">{{ basicInfo.medicalRecordNumber || '未填写' }}</span>
        </div>
        <div class="info-item">
          <span class="label">电话:</span>
          <span class="value">{{ basicInfo.phone || '未填写' }}</span>
        </div>
        <div class="info-item">
          <span class="label">身高:</span>
          <span class="value">{{ basicInfo.height || '未填写' }} 厘米</span>
        </div>
        <div class="info-item">
          <span class="label">体重:</span>
          <span class="value">{{ basicInfo.weight || '未填写' }} 公斤</span>
        </div>
        <div class="info-item">
          <span class="label">年龄:</span>
          <span class="value">{{ basicInfo.age || '未填写' }} 岁</span>
        </div>
        <div class="info-item">
          <span class="label">性别:</span>
          <span class="value">{{ basicInfo.gender || '未填写' }}</span>
        </div>
        <div class="info-item">
          <span class="label">最近症状:</span>
          <span class="value">{{ basicInfo.recentSymptoms || '未填写' }}</span>
        </div>
        <div class="info-item">
          <span class="label">既往病史:</span>
          <span class="value">{{ basicInfo.pastMedicalHistory || '无' }}</span>
        </div>
      </div>

      <!-- 问诊 -->
      <div v-if="activeTab === 'wenzhen'" class="tab-content">
        <h3>问诊结果</h3>
        <div v-if="wenzhenInfo.physique" class="info-item">
          <span class="label">体质分析:</span>
          <span class="value">{{ wenzhenInfo.physique }}</span>
        </div>
        <div v-if="wenzhenInfo.zangfu" class="info-item">
          <span class="label">五脏症状:</span>
          <span class="value">{{ wenzhenInfo.zangfu }}</span>
        </div>
        <div v-if="wenzhenInfo.rhinitis" class="info-item">
          <span class="label">鼻炎症状:</span>
          <span class="value">{{ wenzhenInfo.rhinitis }}</span>
        </div>
        <div v-if="wenzhenInfo.analysisResult" class="info-item">
          <span class="label">诊断结果:</span>
          <div class="analysis-result">
            <p v-for="(item, index) in wenzhenInfo.analysisResult" :key="index">
              {{ item }}
            </p>
          </div>
        </div>
        <div v-else class="no-data">
          暂无问诊数据，请先完成问诊并提交
        </div>
      </div>

      <!-- 闻诊 -->
      <div v-if="activeTab === 'voice'" class="tab-content">
        <h3>闻诊记录</h3>
        <div v-if="wenzhenAudio.audioUrl" class="audio-container">
          <audio :src="wenzhenAudio.audioUrl" controls></audio>
          <div class="info-item">
            <span class="label">上传时间:</span>
            <span class="value">{{ wenzhenAudio.uploadTime }}</span>
          </div>
          <div class="info-item">
            <span class="label">音频时长:</span>
            <span class="value">{{ wenzhenAudio.duration || '未知' }}</span>
          </div>
          <div v-if="wenzhenAudio.analysisResult" class="info-item">
            <span class="label">分析结果:</span>
            <div class="analysis-result">
              <p> tone: {{ wenzhenAudio.analysisResult.tone }}</p>
              <p> strength: {{ wenzhenAudio.analysisResult.strength }}</p>
              <p> rhythm: {{ wenzhenAudio.analysisResult.rhythm }}</p>
              <p> diagnosis: {{ wenzhenAudio.analysisResult.diagnosis }}</p>
            </div>
          </div>
        </div>
        <div v-else class="no-data">
          暂无音频数据，请先完成闻诊并提交
        </div>
      </div>

      <!-- 脉诊 -->
      <div v-if="activeTab === 'pulse'" class="tab-content">
        <h3>脉诊记录</h3>
        <div v-if="maizhenInfo.fileUrl" class="file-container">
          <div class="info-item">
            <span class="label">文件名:</span>
            <span class="value">{{ maizhenInfo.fileName }}</span>
          </div>
          <div class="info-item">
            <span class="label">文件类型:</span>
            <span class="value">{{ maizhenInfo.fileType }}</span>
          </div>
          <div class="info-item">
            <span class="label">上传时间:</span>
            <span class="value">{{ maizhenInfo.uploadTime }}</span>
          </div>
          <div v-if="maizhenInfo.analysisResult" class="info-item">
            <span class="label">脉象分析:</span>
            <div class="analysis-result">
              <p v-for="(item, index) in maizhenInfo.analysisResult" :key="index">
                {{ item.name }}: {{ item.value }}
              </p>
            </div>
          </div>
          <button @click="downloadFile(maizhenInfo.fileUrl, maizhenInfo.fileName)">下载文件</button>
        </div>
        <div v-else class="no-data">
          暂无脉诊数据，请先完成脉诊并提交
        </div>
      </div>

      <!-- 面诊 -->
      <div v-if="activeTab === 'face'" class="tab-content">
        <h3>面诊记录</h3>
        <div v-if="mianzhenInfo.photoUrl" class="photo-container">
          <img :src="mianzhenInfo.photoUrl" alt="面部照片">
          <div class="info-item">
            <span class="label">上传时间:</span>
            <span class="value">{{ mianzhenInfo.uploadTime }}</span>
          </div>
          <div v-if="mianzhenInfo.analysisResult" class="info-item">
            <span class="label">分析结果:</span>
            <div class="analysis-result">
              <p v-for="(item, key) in mianzhenInfo.analysisResult" :key="key">
                {{ key }}: {{ item }}
              </p>
            </div>
          </div>
        </div>
        <div v-else class="no-data">
          暂无面诊数据，请先完成面诊并提交
        </div>
      </div>

      <!-- 舌诊 -->
      <div v-if="activeTab === 'tongue'" class="tab-content">
        <h3>舌诊记录</h3>
        <div v-if="shezhenInfo.photoUrl" class="photo-container">
          <img :src="shezhenInfo.photoUrl" alt="舌头照片">
          <div class="info-item">
            <span class="label">上传时间:</span>
            <span class="value">{{ shezhenInfo.uploadTime }}</span>
          </div>
          <div v-if="shezhenInfo.analysisResult" class="info-item">
            <span class="label">分析结果:</span>
            <div class="analysis-result">
              <p v-for="(item, index) in shezhenInfo.analysisResult" :key="index">
                {{ item.name }}: {{ item.value }}
              </p>
            </div>
          </div>
        </div>
        <div v-else class="no-data">
          暂无舌诊数据，请先完成舌诊并提交
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

export default {
  name: 'UserView',
  // props 配置，用于声明组件可以接收的属性
  props: {
    basicInfo: {
      type: Object,        // 类型检查：必须是对象
      default: () => ({})  // 默认值：返回空对象的函数
    },
    wenzhenInfo: {
      type: Object,
      default: () => ({})
    },
    wenzhenAudio: {
      type: Object,
      default: () => ({})
    },
    shezhenInfo: {
      type: Object,
      default: () => ({})
    },
    maizhenInfo: {
      type: Object,
      default: () => ({})
    },
    mianzhenInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      activeTab: 'basic',
      hasShownHint: false, // 添加标志记录是否已显示提示
      isLoading: false // 添加加载状态
    };
  },
  computed: {
    appData() {
      return this.$parent || {};
    },


  },
  mounted() {
    // 组件挂载后显示操作提示
    this.showOperationHint();
  },
  methods: {
    async showOperationHint() {
      // 如果已经显示过，不再重复显示
      if (this.hasShownHint) return;

      try {
        // 使用SweetAlert2显示个人信息综合页面操作提示
        document.documentElement.scrollTop = 0;
        const result = await Swal.fire({
          title: '操作提示',
          html: `<div class="justified-text">
            <strong>个人信息综合页面使用说明：</strong><br><br>
            1. 本页面汇总了您在基本信息、问诊、面诊、舌诊、闻诊、脉诊各模块提交的所有数据<br>
            2. 您可以通过顶部的标签页切换查看不同诊断类型的信息<br>
            3. 所有数据均为实时更新，请确保在各模块点击"保存"按钮<br>
            4. 您可以查看、下载已上传的文件和照片<br><br>
            
          </div>`,
          imageWidth: 200,
          imageHeight: 200,
          showCancelButton: true,
          confirmButtonText: '开始查看',
          cancelButtonText: '返回',
          allowOutsideClick: false, // 禁止点击外部关闭
          backdrop: true, // 显示遮罩层
          showLoaderOnConfirm: true, // 启动确认按钮加载动画
          // 添加自定义类名控制遮罩层
          customClass: {
            container: 'user-view-operation-container',
            popup: 'user-view-operation-popup'
          }
        });

        if (result.isConfirmed) {
          // 用户点击"开始查看"
          this.isLoading = true;

          // 延迟1秒后关闭加载动画并滚动到顶部
          setTimeout(() => {
            this.isLoading = false;
            this.hasShownHint = true;

            // 滚动到页面顶部
            this.scrollToTop();

            // 显示成功通知
            this.$notify({
              title: '提示',
              message: '您可以开始查看个人信息综合数据了',
              type: 'success',
              duration: 3000
            });
          }, 1000);

        } else if (result.dismiss === Swal.DismissReason.cancel) {
          // 用户点击"返回"，导航回上一个页面
          this.$router.go(-1);
        }
      } catch (error) {
        console.error('操作提示显示失败:', error);
        // 即使提示失败，仍然允许用户继续使用
        this.hasShownHint = true;
      }
    },

    // 切换标签页
    switchTab(tab) {
      this.activeTab = tab;
    },
    // 文件下载
    downloadFile(url, fileName) {
      // 创建一个临时的a标签元素
      const link = document.createElement('a');
      // 设置下载文件的URL和文件名
      link.href = url;
      link.download = fileName;
      // 将a标签添加到页面中
      document.body.appendChild(link);
      // 模拟点击触发下载
      link.click();
      // 下载完成后移除临时元素
      document.body.removeChild(link);
    }
  }
};
</script>

<style scoped>
.user-view-container {
  padding: 20px;
  font-family: Arial, sans-serif;
}

h2 {
  color: #333;
  border-bottom: 2px solid #42b983;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

h3 {
  color: #42b983;
  margin-top: 0;
}

.tabs-container {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  gap: 10px;
}

.tabs-container button {
  padding: 10px 15px;
  background-color: #f0f0f0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.tabs-container button:hover {
  background-color: #e0e0e0;
}

.tabs-container button.active {
  background-color: #42b983;
  color: white;
}

.content-container {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tab-content {
  animation: fadeIn 0.3s;
}

.info-item {
  display: flex;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.label {
  font-weight: bold;
  width: 100px;
  color: #555;
}

.value {
  flex: 1;
  word-break: break-word;
}

.audio-container audio {
  width: 100%;
  margin-bottom: 15px;
}

.photo-container img {
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  padding: 5px;
  border-radius: 4px;
}

.file-container button {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
}

.file-container button:hover {
  background-color: #3aa876;
}

.no-data {
  color: #999;
  text-align: center;
  padding: 20px;
  font-style: italic;
}

.analysis-result {
  margin-top: 5px;
  padding-left: 10px;
  border-left: 2px solid #42b983;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .tabs-container {
    flex-direction: column;
  }

  .tabs-container button {
    width: 100%;
  }

  .label {
    width: 100%;
    margin-bottom: 5px;
  }
}
</style>